import "./planes.css";
import Employer from "../../components/employer";

const Planes = () => {
  return (
    <div className="plans-section">
      {/* Encabezado de la sección */}
      <div className="section-header">
        <h1 className="display-4 planes-section-title">PLANES</h1>
        <p className="planes-section-subtitle lead">
          Elige el plan que mejor se ajuste a tus necesidades
        </p>
      </div>

      {/* Planes para Usuario Normal */}
      <div className="plan-category user-plans">
        <h2 className="category-title">Usuario</h2>
        <div className="plans-grid">
          {/* Plan Básico */}
          <div className="plan-card">
            <h3 className="plan-card-title">Plan Básico</h3>
            <ul className="plan-features">
              <li>Acceso a empleos generales</li>
              <li>Crear alertas de empleo</li>
              <li>Guardar empleos como favoritos</li>
              <li>Recursos educativos, de emprendimiento y migratorios limitados</li>
            </ul>
            <button className="plan-button">Comienza Gratis</button>
          </div>

          {/* Plan Premium */}
          <div className="plan-card">
            <h3 className="plan-card-title">Plan Premium</h3>
            <ul className="plan-features">
              <li>Todo lo del plan básico</li>
              <li>Acceso prioritario a empleos destacados</li>
              <li>Recursos exclusivos</li>
            </ul>
            <button className="plan-button">Suscríbete por US$5.99/mes</button>
          </div>

          {/* Plan Pro */}
          <div className="plan-card">
            <h3 className="plan-card-title">Plan Pro</h3>
            <ul className="plan-features">
              <li>Todo lo del plan Premium</li>
              <li>Sesiones de coaching individualizadas</li>
            </ul>
            <button className="plan-button">Suscríbete por US$9.99/mes</button>
          </div>
        </div>
      </div>

      {/* Planes para Empleador */}
      <div className="plan-category employer-plans">
        <h2 className="category-title">Empleador</h2>
        <div className="plans-grid">
          {/* Plan Básico */}
          <div className="plan-card">
            <h3 className="plan-card-title">Plan Básico</h3>
            <ul className="plan-features">
              <li>Publica hasta 1 empleo al mes</li>
              <li>Acceso limitado a candidatos</li>
            </ul>
            <button className="plan-button">Comienza Gratis</button>
          </div>

          {/* Plan Empresarial */}
          <div className="plan-card">
            <h3 className="plan-card-title">Plan Empresarial</h3>
            <ul className="plan-features">
              <li>Publica hasta 5 empleos por mes</li>
              <li>Acceso a base amplia de candidatos</li>
              <li>Herramientas para gestionar candidatos</li>
              <li>Recursos exclusivos</li>
            </ul>
            <button className="plan-button">Suscríbete por US$9.99/mes</button>
          </div>

          {/* Plan Corporativo */}
          <div className="plan-card">
            <h3 className="plan-card-title">Plan Corporativo</h3>
            <ul className="plan-features">
              <li>Publica hasta 5 empleos por mes</li>
              <li>Empleos destacados</li>
              <li>Informes y análisis avanzados</li>
            </ul>
            <button className="plan-button">Suscríbete por US$19.99/mes</button>
          </div>
        </div>
      </div>

      {/* Plan Personalizado */}
      <div className="plan-category custom-plan">
        <h2 className="category-title">Plan Personalizado</h2>
        <p className="custom-plan-description">
          Contáctanos para planes a medida que se adapten a tus necesidades.
        </p>
        <button className="plan-button custom-plan-button">Escríbenos</button>
      </div>

      {/* Sección adicional: Regístrate o más información */}
      <Employer />
    </div>
  );
};

export default Planes;